module.exports = __webpack_public_path__ + "static/media/leaf.f33f81ab.png";